import React from 'react'

import { NavLink } from 'react-router-dom'
import { ReactComponent as Twitter } from '../assets/twitter.svg'
import { ReactComponent as Instagram } from '../assets/instagram.svg'

const Navigation = () => {

    return (
        <nav>
            <div className="container">
                <div className="nav-columns">
                    <div className="nav-column">
                        <div className="nav-label">Menu</div>
                        <ul className="nav-links">
                            <li>
                                <NavLink to="/about">
                                    About Us
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/how-we-work">
                                    How We Work
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/services">
                                    Services
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact">
                                    Contact Us
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="nav-column">
                        <div className="nav-label">Contact</div>
                        <div className="nav-infos">
                            <ul className="nav-info">
                                <li className="nav-info-label">Email</li>
                                <li>
                                    <a href='&#109;&#97;&#105;l&#116;o&#58;inf&#111;&#64;%&#55;0%&#54;&#53;%74al&#46;p%7&#55;'>&#105;nfo&#64;peta&#108;&#46;pw</a>
                                </li>
                                <li>
                                    <NavLink to="/contact">
                                        Get a free audit
                                    </NavLink>
                                </li>
                            </ul>
                            <ul className="nav-info">
                                <li className="nav-info-label">Office</li>
                                <li>Studio8</li>
                                <li>Suwung</li>
                                <li>Denpasar, Bali</li>
                            </ul>
                            <ul className="nav-info">
                                <li className="nav-info-label">Phone</li>
                                <li>+62 081 999 527 649</li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navigation
